<template>
    <div v-bind:class="[ 'select-col', 'component-' + box.component]">
        <div class="top-step-name basic-border basic-color">{{ box.title }}</div>
        <div class="designer-detailbox-description">
            <p><span id="detail-description">{{{ box.todo }}}</span></p>
        </div>

        <!-- Modal -->
        <div class="modal-mask" v-show="show" transition="modal">
            <div class="modal-wrapper">
                <div class="modal-container">

                    <div class="modal-header"></div>
                    <div class="modal-body">
                        <div id="ajax_summary_content" class="addtoCart"><h1>Zusammenfassung</h1>
                            <div class="ajax_summary_innerframe">

                                <form v-if="items" :action="items.checkoutUrl" method="post" id="product_addtocart_form"
                                      enctype="multipart/form-data">


                                    <!-- Generate SUMMARY TABLE -->
                                    <div class="data-table" id="summary-table">
                                        <div class="row">
                                            <div class="sum-col header">Attribut</div>
                                            <div class="sum-col header">Konfiguration</div>
                                        </div>
                                        <div v-for="item in items.shirt"
                                             v-if="['monogramm_prefix', 'monogramm_yarn', 'monogramm_font'].indexOf($key) < 0 "
                                             class="row">
                                            <div class="sum-col attrtitle">{{ item.cat }}</div>
                                            <div class="sum-col">{{ item.transl }}</div>
                                        </div>

                                    </div>

                                    <!-- Generate HIDDEN FIELDS -->
                                    <input v-for="item in items.shirt" type="text"
                                           class="input-text required-entry product-custom-option"
                                           :name="'options['+item.id+']'" :id="$key" :value="item.val"
                                           style="display:none;">
                                    <!-- Generate MEASURE TABLE -->
                                    <div class="data-table" id="my-measurementstop-table">
                                        <div class="title">Maßprofil</div>
                                        <div v-for="item in items.tab" class="sum-col smallwidth">
                                            <div class="attrtitle">{{ item.head }}</div>
                                            <div>{{ item.transl }}</div>
                                        </div>
                                    </div>
                                    <input v-for="item in items.tab" v-if="item.data.length" type="text"
                                           class="input-text required-entry product-custom-option"
                                           :name="'options['+item.id+']'" :id="$key" :value="item.data"
                                           style="display:none;">
                                    <div class="summarybutton">
                                        <button class="button btn-cart buttonoverviewaddtocart" title="In den Warenkorb"
                                                type="button" @click="this.$parent.clearViewCount()"><span>In den Warenkorb</span>
                                        </button>
                                        <button class="button btn-cart modal-default-button" type="button"
                                                @click="show = false">
                                            {{ globals.translations['Close'] }}
                                        </button>
                                    </div>
                                </form>
                                <div class="modal-footer">
                                    <slot name="footer">

                                    </slot>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- // End Modal -->
    </div>
</template>


<script>
export default {
  name: 'Checkout',
  props: { 'fabrics': '', 'items': '', 'box': '', modalcontent: [],
    show: {
      type: Boolean,
      required: true,
      twoWay: true
    }
  },
  data: function () {
    return {
      globals: window.shirtdesigner
    }
  },
  ready: function () {
    this.$dispatch('runDesignJQuery')
  }
}

</script>



// WEBPACK FOOTER //
// Checkout.vue?28a73768